export default {
      id: "stats-usage",
      viewBox: "0 0 20 12",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#stats",
      toString: function () {
        return this.url;
      }
    }